<script lang="ts" setup>
</script>

<template>
  <div class="brandguide" v-once>
    <div class="document-page">
      <h1 class="text-center">OpenAtom Foundation Brand Usage Guidelines</h1>
      <p class="text-center">Version number: 2.0</p>
      <p class="text-center">Publication date: June 7, 2022</p>
      &emsp;&emsp;OpenAtom Foundation (hereinafter referred to as the "Foundation"), as a neutral, open and non-profit charitable organization, holds the intellectual property rights and legitimate rights and interests relating to the Foundation and all the projects (groups) operated by it, including but not limited to all the trademarks and trade names (hereinafter referred to as <b class="smallHand"><a href="https://res.oafimg.cn/-/74491fba19f02e78/trademarks.xlsx">the Foundation Brands</a></b>) in relation to the Foundation and all the projects (groups) operated by it.
      <p>
        &emsp;&emsp;In order to maintain the legitimate goodwill and brand value of the Foundation Brands, we hereby drew up and published the OpenAtom Foundation Brand Usage Guidelines (hereinafter referred to as the "Guidelines"). The Foundation hopes to work together with all the contributors and community partners participating in the open source ecosystem (hereinafter referred to as "You") to jointly use the Foundation Brands in a legitimate and appropriate manner.
      </p>
      <h4>1. Usage Circumstances</h4>
      <h4>1.1. Circumstances not requiring the permission of the foundation (fair use)</h4>
      <p>
        &emsp;&emsp;You may make fair use of the Foundation Brands in a limited way under Trademark law to make true factual statements in relation to the Foundation and its projects (groups), rather than use them as a trademark to indicate the source of goods or services. In this case, you need not to obtain the prior permission from the Foundation.
      </p>
      <p>
        &emsp;&emsp;Please note that the "fair use" of trademarks shall be in good faith, reasonable and necessary for the purposes and methods of use. You shall not cause relevant public to misunderstand the relationship between You and the Foundation and its projects (groups), including not to express or imply that the Foundation and its project (group) work committee sponsor, endorse or support your company, products or services, etc. Generally speaking, the "fair use" is only limited to the use of trademarks in the true factual statement in the non-highlighted text form, rather than use the trademarks that contain typeface design and/or graphics.
      </p>
      <div></div>
      <p>
        &emsp;&emsp;While You make fair use of the Foundation Brands, please also indicate that the relevant trademark is a trademark owned by the Foundation in an appropriate manner, for instance, indicate on the same page where the trademark is used that: “the [Relevant Trademark™/Relevant Trademark®] is a legitimate trademark owned by OpenAtom Foundation with corresponding rights and interests." If You are unsure about whether a trademark of the Foundation has been registered in the country/region where you intend to use, please check through the Foundation Brands page.
      </p>
      <h4>1.2. Circumstances having implied permission of the foundation</h4>
      <p>
        &emsp;&emsp;On the premise of complying with these Guidelines (such as usage rules, prohibited circumstances, etc.), the Foundation tacitly allows You to use the Foundation Brands in good faith in the form of text and/or standard style under the following non-commercial usage scenarios:
      </p>
      <p>
        &emsp;&emsp;(1) When You set a hyperlink directly jumping to the official website of the Foundation and its projects (groups) on a web page for non-commercial purposes, You may use the text and/or standard style of the corresponding trademark as a link button.
      </p>
      <p>
        &emsp;&emsp;(2) When You introduce the relevant facts of the Foundation and its projects (groups) in the publicity materials for non-commercial purposes, You may use the text and/or standard style of the corresponding trademark.
      </p>
      <p>
        &emsp;&emsp;(3) When You make no more than 20 pieces of common cultural peripheral products such as T-shirts and caps for non-commercial purposes, You may use the text and/or standard style of the corresponding trademark.
      </p>
      <h4>1.3. Circumstances subject to the permission of the foundation</h4>
      <p>
        &emsp;&emsp;Except for “fair use” and implied permissions mentioned above, you should obtain the permission from the Foundation to use the Foundation Brands, especially including but not limited to the following circumstances:
      </p>
      <ul>
        <li>
          <p>
            use on products and services, such as: using the Foundation Brands on packaging or decoration, so as to express or imply that the Foundation and its relevant project working committees sponsor, endorse or support your company, products or services.
          </p>
        </li>
        <li>
          <p>
            use in conferences, events and activities, such as: using the Foundation Brands on posters or exhibition boards, so as to express or imply that the Foundation or its project (group) working committees guide, host, co-organize, undertake, support your conferences, events and activities, etc.
          </p>
        </li>
        <li>
          <p>
            use in the name of a company or institution, such as: using the Foundation Brands as a part of an institution name.
          </p>
        </li>
        <li>
          <p>
            use in social media accounts and names, such as: using the Foundation Brands as a part of the account name publicly displayed.
          </p>
        </li>
        <li>
          <p>
            use in domain names and web pages, such as: using the Foundation Brands as a part of domain name, or displaying the Foundation Brands on web pages.
          </p>
        </li>
        <li>
          <p>use on certificates and business cards, such as: displaying the Foundation Brands on certificates and business cards.</p>
        </li>
        <li>
          <p>
            use in publications and publicity materials (for commercial purposes), such as: using the Foundation Brands on the front or back cover of publications, or in the institutional publicity brochures and other materials.
          </p>
        </li>
        <li>
          <p>
            use on cultural peripheral products, such as: using the trademarks of the Foundation or its projects (groups) on common cultural peripheral products such as T-shirts and caps that are sold externally or distributed in the process of commercial promotion.
          </p>
        </li>
      </ul>
      <p>
        &emsp;&emsp;You shall obtain the written permission from the Foundation to use the trademark beford your actual using the Foundation Brands. Application method: contact us. by email with a subject of "Brand Usage Application - [Specific Trademark]", for which the main body of the email shall contain the following information:
      </p>
      <ul>
        <li>proposed user (please provide the real name of the individual or the full name of the legal person)</li>
        <li>proposed usage circumstances (please describe the specific circumstances under which You use the Foundation Brands)</li>
        <li>proposed usage methods (please upload the design drawings or schematic diagrams relating to all the circumstances that You intend to use)</li>
        <li>proposed usage scope</li>
        <li>proposed period of usage (and please explain the necessity of the period of usage according to your actual situation)</li>
      </ul>
      <p>
        &emsp;&emsp;If the trademark(s) is permitted to use by a written confirmation from the Foundation, the trademark user shall use the corresponding trademark in accordance with the usage circumstances, usage methods, usage scope and usage period as stated in the email application.
      </p>
      <h4>1.4. Circumstances prohibited from use</h4>
      <p>&emsp;&emsp;Any use or reference of the Foundation Brands that is inconsistent with the requirements of these Guidelines is prohibited.</p>
      <p>&emsp;&emsp;Any defamatory or derogatory use of the Foundation Brands is prohibited.</p>
      <p>&emsp;&emsp;Any use of the Foundation Brands that is false or misleading promotion is prohibited.</p>
      <p>
        &emsp;&emsp;Any use of logos, advertising slogans and slogans, etc. that are likely to cause confusion with the Foundation Brands is prohibited.
      </p>
      <h4>2. Usage Rules</h4>
      <p>
        &emsp;&emsp;(1) If You have obtained the implied or written permission to use the Foundation Brands, please download the standard style of the Foundation Brands for standardized usage. When using a trademark in the standard style, You are not allowed to remove, distort or tamper with any element of the trademark, for exemple: it's not allowed to combine with any other letter or word, use in the plural or possessive forms, abbreviate or hyphenate, or change colors, etc. If You have to zoom out the standard style, You must keep the original scale.
      </p>
      <p>
        &emsp;&emsp;(2) You shall not highlight the Foundation Brands prominently over your own company, product or service trademarks.
      </p>
      <p>
        &emsp;&emsp;(3) Please include appropriate attribution of Foundation’s ownership of its trademarks when You use them. For instance, indicate on the same page where the trademark is used that: “the [Relevant Trademark™/Relevant Trademark®] is a legitimate trademark owned by OpenAtom Foundation."
      </p>
      <p>
        &emsp;&emsp;(4) Any use of registered trademarks under the Foundation Brand shall be marked with trademark symbol ® . Any use of unregistered trademarks under the Foundation Brand shall be marked wtih trademark symbol™ . If You are unsure about whether a trademark of the Foundation is registered in the country/region where You intend to use, please check through the Foundation Brands page or contact us.
      </p>
      <p>
        &emsp;&emsp;(5) Please note that the projects (groups) under the Foundation may have further requirements for the use of their project (group) brands. Please refer to the brand usage guidelines of corresponding projects (groups) under the Foundation to learn more about how to use such project (group) trademarks.
      </p>
      <h4>3. Contact Information</h4>
      <p>
        &emsp;&emsp;If You have any questions about these Guidelines, or about the usage or abuse of the Foundation Brands, or if You wish to obtain written permission to use the Foundation Brands, contact us.
      </p>
      <h4>4. Statement</h4>
      <p>
        &emsp;&emsp;The Foundation does not make any express or implied warranties for the usage of the Foundation Brands, including but not limited to the warranties of non-infringement of any third party’s intellectual property rights, and warranties  that any pending trademark application for the Foundation Brands will be protected by registered  trademark, etc.
      </p>
      <p>
        &emsp;&emsp;Third parties using the Foundation Brands agree to take all the liabilities for any claims relating to the activities or products using the Foundation Brands, and hereby agree to indemnify and hold the Foundation, all its projects (groups) and its contributors harmless against any such claims. Any content (including examples) of these Guidelines does not affect any rights, interests and claims held by the Foundation according to law.
      </p>
      <h4>5. Updates</h4>
      <p>
        &emsp;&emsp;The Foundation may revise these Guidelines from time to time, and release new versions of these Guidelines on the official website of the Foundation (www.openatom.cn). Please confirm that You are in compliance with the latest version of these Guidelines prior to using the Foundation Brands or applying for their use.
      </p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.document-page {
  width: 1200px;
  margin: 40px auto;
}

a {
  color: inherit;
  text-decoration: none;
}

.under {
  text-decoration: underline;
  cursor: pointer;
}

.under:hover {
  color: red;
  text-decoration: underline;
}

.smallHand {
  cursor: pointer;
}
</style>
